import { render, staticRenderFns } from "./checkoutSuccessLottie.vue?vue&type=template&id=56f73f9e&scoped=true"
import script from "./checkoutSuccessLottie.vue?vue&type=script&lang=js"
export * from "./checkoutSuccessLottie.vue?vue&type=script&lang=js"
import style0 from "./checkoutSuccessLottie.vue?vue&type=style&index=0&id=56f73f9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f73f9e",
  null
  
)

export default component.exports